<template>
  <Container>
    <div class="home_pc">
      <img src="@/assets/bg1.png" class="bg1">
      <img src="@/assets/bg2.png" class="bg2">
      <div class="variable-container">
        <el-carousel :indicator-position="showIndicator" arrow="never" :autoplay="false" @change="carouselChange">
          <el-carousel-item v-for="item in videos" :key="item">
            <div class="carousel-video">
              <video
              :src="item.src"
              :poster="item.poster"
              controls
              ref="video"
              @play="videoPlayState = true"
              @pause="videoPlayState = false"
              @ended="videoPlayState = false"></video>
            </div>
          </el-carousel-item>
        </el-carousel>
        <div class="story-area">
          <div class="cover">
            <img :src="currentStory.cover">
            <div class="total-time">{{ totalAudioDuration }}</div>
            <div class="share">
              <img src="@/assets/twitter.png" @click="setTwitterLink(currentStory.title)">
              <img src="@/assets/facebook.png" @click="setFacebookLink">
            </div>
          </div>
          <div class="story-info">
            <div class="title" :style="{left: currentStory.audioUrl ? '0' : '50px'}">
              <div class="play-icon" v-if="currentStory.audioUrl" @click="audioStartPlay">
                <img src="@/assets/icon2.png" v-if="storyPlayState">
                <img src="@/assets/icon1.png" v-else>
              </div>
              <div class="titleTex">
                <span><i>{{ currentStory.title }}</i></span>
              </div>
            </div>
            <div class="story-desc" :style="{marginTop: currentStory.audioUrl ? '0' : '50px'}">
              <div v-html="currentStory.desc"></div>
              <div>{{ currentStory.author }}</div>
            </div>
          </div>
        </div>
        <ul class="story-list" v-vscrollCenter="currentStoryIndex">
          <li v-for="(i, index) in audios" :class="{active: index===currentStoryIndex}" @click="currentStoryIndex = index">
            <img :src="i.cover">
            <i class="indicator" v-show="index===currentStoryIndex"></i>
            <div class="play-mask" v-show="index===currentStoryIndex">
              <img src="@/assets/icon3.png" alt="">
            </div>
          </li>
        </ul>
      </div>
      <div class="story-controller" v-if="currentStory.audioUrl">
        <div class="story-content">
          <div class="story-info">
            <img :src="currentStory.cover">
            <div class="title-text">
              {{ currentStory.title }}
            </div>
          </div>
          <ul>
            <li>
              <img src="@/assets/icon10.png" @click="forwardOrback(-20)">
            </li>
            <li @click="nextOrPreviousEpisode('previous')">
              <img src="@/assets/icon12.png">
            </li>
            <li @click="audioStartPlay">
              <img src="@/assets/icon9.png" v-if="storyPlayState">
              <img src="@/assets/icon8.png" v-else>
            </li>
            <li @click="nextOrPreviousEpisode('next')">
              <img src="@/assets/icon13.png">
            </li>
            <li>
              <img src="@/assets/icon11.png" @click="forwardOrback(20)">
            </li>
            <li>
              <img src="@/assets/icon6.png" v-show="speed === 0.5" @click="playbackRate(1)">
              <img src="@/assets/icon7.png" v-show="speed === 1" @click="playbackRate(0.5)">
            </li>
          </ul>
        </div>
      </div>
      <audio :src="currentStory.audioUrl" v-show="false" ref="audio" @ended="storyPlayState = false" @loadedmetadata="audioLoadedmetadata"></audio>
    </div>
  </Container>
</template>

<script>
import Container from '@/components/container.vue';
import mixins from '@/mixins'
export default {
  name: 'Home',
  mixins: [mixins],
  components: {
    Container
  }
}
</script>

<style lang='less' scoped>
.home_pc{
  min-height: 100vh;
  background: #0156BD;
  position: relative;
  padding-top: 1200px;
  .bg1{
    position: absolute;
    top: 0;
  }
  .bg2{
    position: absolute;
    bottom: 0;
  }
  .variable-container{
    width: 1530px;
    margin: 0 auto;
    position: relative;
    // z-index: 1000;
    /deep/ .el-carousel__container{
      height: 1000px;
    }
    .carousel-video{
      width: 100%;
      height: 861px;
      margin: 0 auto;
      video{
        width: 100%;
        height: 861px;
      }
    }
    .story-area{
      background: #80ABDE;
      padding: 40px;
      border-radius: 50px;
      position: relative;
      display: flex;
      .cover{
        flex-shrink: 0;
        width: 539px;
        height: 539px;
        border: 5px solid #fff;
        border-radius: 50px;
        overflow: hidden;
        position: relative;
        img{
          width: 100%;
          height: 100%;
        }
        .total-time{
          position: absolute;
          bottom: 20px;
          right: 20px;
          font-size: 40px;
          color: #fff;
        }
        .share{
          position: absolute;
          top: 20px;
          right: 30px;
          display: flex;
          gap: 40px;
          img{
            width: 60px;
          }
        }
      }
      .story-info{
        color: #fff;
        .title{
          display: flex;
          align-items: center;
          position: relative;
          .play-icon{
            img{
              width: 180px;
            }
          }
          .titleTex{
            font-size: 60px;
          }
        }
        .story-desc{
          padding-left: 50px;
          font-size: 30px;
          margin-top: 20px;
        }
      }
    }
    .story-list{
      display: flex;
      overflow: auto;
      gap: 62px;
      padding: 80px 15px;
      li{
        flex-shrink: 0;
        width: 130px;
        height: 130px;
        border-radius: 50%;
        border: 2px solid #fff;
        position: relative;
        box-sizing: content-box;
        img{
          width: 100%;
          height: 100%;
          border-radius: 50%;
        }
        .play-mask{
          width: 130px;
          height: 130px;
          background: #00000070;
          border-radius: 50%;
          position: absolute;
          bottom: 0;
          left: 0;
          img{
            transform: scale(0.5);
          }
        }
      }
      .active{
        &::after{
          content: '';
          position: absolute;
          top: -100px; /* 调整三角形位置 */
          left: 50%; /* 使三角形的角尖对准li元素中心 */
          transform: translateX(-50%) rotate(180deg);
          border-width: 50px;
          border-style: solid;
          border-color: transparent transparent #80ABDE transparent;
        }
      }
    }
  }
  .story-controller{
    width: 100vw;
    height: 167px;
    background: #23293c9f;
    position: relative;
    padding: 15px 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 14px;
    color: #fff;
    .story-content{
      width: 1530px;
      margin: 0 auto;
      display: flex;
      .story-info{
        display: flex;
        align-items: center;
        gap: 30px;
        img{
          width: 118px;
        }
        .title-text{
          width: 400px;
          font-size: 40px;
        }
      }
      ul{
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: end;
        gap: 50px;
        li{
          width: 70px;
          height: 70px;
          img{
            width: 70px;
            height: 70px;
          }
        }
      }
    }
  }
}
::v-deep .main-footer{
  margin-top: 0 !important;
}
::-webkit-scrollbar {
  height: 0;
}
</style>